<template>
  <el-form ref="formValidate"
           :model="params"
           label-position="right"
           label-width="180px"
           :rules="rules">
    <el-form-item prop="type"
                  :label="$t('dictionary.dictType')">
      <el-input type="text"
                v-model="params.type"
                :placeholder="$t('dictionary.typeRequire')"> </el-input>
    </el-form-item>
    <el-form-item prop="name"
                  :label="$t('dictionary.dictName')">
      <el-input type="text"
                v-model="params.name"
                :placeholder="$t('dictionary.nameRequire')"></el-input>
    </el-form-item>
    <el-form-item prop="value"
                  :label="$t('dictionary.value')">
      <el-input type="text"
                v-model="params.value"
                :placeholder="$t('dictionary.valueRequire')"> </el-input>
    </el-form-item>

    <el-form-item prop="i18nKey"
                  :label="$t('common.i18nKey')">
      <el-input type="text"
                v-model="params.i18nKey"
                :placeholder="$t('common.i18nKeyRequire')"> </el-input>
    </el-form-item>

    <el-form-item prop="sortNo"
                  :label="$t('dictionary.sortNo')">
      <el-input type="text"
                v-model="params.sortNo"
                :placeholder="$t('dictionary.sortNoRequire')"> </el-input>
    </el-form-item>
    <el-form-item prop="remark"
                  :label="$t('common.remark')">
      <el-input type="text"
                v-model="params.remark"
                :placeholder="$t('common.remarkRequire')"> </el-input>
    </el-form-item>
  </el-form>
</template>
<script>
import * as dictService from '../../../services/dictionary'
export default {
  name: 'zk-sys-dict-save-or-update',
  props: ['form', 'isUpdate'],
  data () {
    let rules = {
      type: [{ required: true, message: this.$t('dictionary.typeRequire'), trigger: 'blur' }],
      name: [{ required: true, message: this.$t('dictionary.nameRequire'), trigger: 'blur' }],
      value: [{ required: true, message: this.$t('dictionary.valueRequire'), trigger: 'blur' }],
      i18nKey: [{ required: true, message: this.$t('common.i18nKeyRequire'), trigger: 'blur' }]
    }
    return {
      params: JSON.parse(JSON.stringify(this.form || {})),
      rules
    }
  },
  methods: {
    save () {
      let _self = this
      return new Promise((resolve, reject) => {
        this.$refs.formValidate.validate(valid => {
          if (valid) {
            if (!_self.isUpdate) {
              resolve(dictService.add(_self.params))
            } else {
              resolve(dictService.update(_self.params))
            }
          } else {
            reject(valid)
          }
        })
      })
    },
    resetFields () {
      this.$refs.formValidate.resetFields()
    }
  },
  watch: {
    form (newValue, oldValue) {
      this.params = JSON.parse(JSON.stringify(newValue || oldValue))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/systemDictSaveOrUpdate/src/main.vue